define(['radio', 'common/visual/vertical', "common/visual/vue-module", "client/edit/LastActivity"], function(radio, Vertical, vueMod, lastActivityVue) {
  return Object.create(Vertical).extend({
    name: 'clientInfoTab',
    title: 'Данные',
    icon: 'user',

    layout: [
      { modPath: 'client/edit/info', noBorder: true },
      { module: Object.create(vueMod).extend({vue: lastActivityVue}), noBorder: true },
      { modPath: 'client/tag/tag', noBorder: true },
      { modPath: 'client/file/file', noBorder: true },
    ],
  });
});
